import React from 'react';
import { motion } from 'framer-motion';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .btc-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .btc-page { font-family: 'Inter', sans-serif; color: #0f172a; background: #ffffff; width: 100%; }

  /* ─── Hero ─────────────────────────────────────────────────── */
  .btc-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .btc-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 520px; height: 520px; border-radius: 50%; background: radial-gradient(circle, rgba(139,92,246,0.14), rgba(109,40,217,0.06)); filter: blur(80px); pointer-events: none; }
  .btc-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(16,185,129,0.1), rgba(5,150,105,0.05)); filter: blur(90px); pointer-events: none; }
  .btc-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .btc-hero-inner { grid-template-columns: 1fr; } .btc-hero-visual { display: none; } }
  .btc-back-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.18s ease; margin-bottom: 24px; }
  .btc-back-btn:hover { background: #faf5ff; border-color: #ddd6fe; color: #7c3aed; }
  .btc-hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #faf5ff; border: 1px solid #e9d5ff; font-size: 13px; font-weight: 500; color: #581c87; margin-bottom: 28px; }
  .btc-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: #8b5cf6; display: inline-block; animation: btc-pulse 2s infinite; }
  @keyframes btc-pulse { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(139,92,246,0.4);}50%{opacity:.85;box-shadow:0 0 0 6px rgba(139,92,246,0);} }
  .btc-hero h1 { font-size: clamp(1.8rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0f172a; margin-bottom: 24px; }
  .btc-gradient-text { background: linear-gradient(135deg, #7c3aed, #059669); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .btc-hero p { font-size: 1.15rem; color: #475569; line-height: 1.75; margin-bottom: 40px; font-weight: 300; max-width: 520px; }
  .btc-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .btc-btn-primary { padding: 14px 28px; background: #7c3aed; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .btc-btn-primary:hover { background: #6d28d9; box-shadow: 0 8px 24px rgba(124,58,237,0.35); transform: translateY(-1px); }
  .btc-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1.5px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .btc-btn-secondary:hover { border-color: #ddd6fe; background: #faf5ff; color: #581c87; }

  /* Hero Visual */
  .btc-hero-visual { background: #fff; border-radius: 28px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(124,58,237,0.08); }
  .btc-vis-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .btc-vis-title p:first-child { font-size: 11px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px; }
  .btc-vis-title p:last-child { font-size: 17px; font-weight: 800; color: #0f172a; }
  .btc-vis-icon { width: 46px; height: 46px; background: linear-gradient(135deg, #7c3aed, #8b5cf6); border-radius: 13px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .btc-entity-compare { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 16px; }
  .btc-entity { padding: 14px; border-radius: 12px; border: 1px solid; }
  .btc-entity.current { background: #fff7ed; border-color: #fed7aa; }
  .btc-entity.recommended { background: #f0fdf4; border-color: #d1fae5; }
  .btc-entity-tag { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 6px; }
  .btc-entity-tag.current { color: #b45309; }
  .btc-entity-tag.recommended { color: #059669; }
  .btc-entity-name { font-size: 14px; font-weight: 800; color: #0f172a; margin-bottom: 4px; }
  .btc-entity-tax { font-size: 12px; color: #64748b; margin-bottom: 6px; }
  .btc-entity-amount { font-size: 15px; font-weight: 900; }
  .btc-entity-amount.bad { color: #ef4444; }
  .btc-entity-amount.good { color: #059669; }
  .btc-entity-savings { margin-top: 16px; padding: 14px 16px; background: linear-gradient(135deg, #7c3aed, #8b5cf6); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .btc-entity-savings span:first-child { font-size: 13px; color: rgba(255,255,255,0.75); }
  .btc-entity-savings span:last-child { font-size: 17px; font-weight: 900; color: #fff; }

  /* ─── Stats ─────────────────────────────────────────────────── */
  .btc-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .btc-stats-grid { display: grid; grid-template-columns: repeat(4,1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .btc-stats-grid { grid-template-columns: repeat(2,1fr); } }
  .btc-stat { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .btc-stat:last-child { border-right: none; }
  @media (max-width: 768px) { .btc-stat:nth-child(2n){ border-right:none; } .btc-stat{ border-bottom:1px solid #f1f5f9; } }
  .btc-stat-num { font-size: 2.2rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; color: #7c3aed; }
  .btc-stat-num.dark { color: #0f172a; }
  .btc-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ─── Section Base ───────────────────────────────────────────── */
  .btc-section { padding: 96px 24px; }
  .btc-container { max-width: 1200px; margin: 0 auto; }
  .btc-section-header { text-align: center; max-width: 700px; margin: 0 auto 64px; }
  .btc-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .btc-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.75; }
  .btc-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #7c3aed; margin-bottom: 12px; }

  /* ─── Areas ──────────────────────────────────────────────────── */
  .btc-areas { background: #f8fafc; }
  .btc-areas-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
  @media (max-width: 900px) { .btc-areas-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .btc-areas-grid { grid-template-columns: 1fr; } }
  .btc-area-card { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; padding: 32px; transition: all 0.3s; position: relative; overflow: hidden; }
  .btc-area-card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background: linear-gradient(90deg,#7c3aed,#059669); transform:scaleX(0); transform-origin:left; transition:transform 0.3s; }
  .btc-area-card:hover::before { transform:scaleX(1); }
  .btc-area-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); border-color: #ddd6fe; }
  .btc-area-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 20px; }
  .btc-area-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 10px; }
  .btc-area-card p { font-size: 0.9rem; color: #64748b; line-height: 1.7; margin-bottom: 16px; }
  .btc-area-impact { display: inline-block; padding: 4px 12px; background: #faf5ff; color: #7c3aed; border-radius: 999px; font-size: 12px; font-weight: 700; }

  /* ─── Entity Guide ───────────────────────────────────────────── */
  .btc-entity-guide { background: #fff; }
  .btc-entity-guide-inner { background: #0f172a; border-radius: 32px; padding: 80px 64px; position: relative; overflow: hidden; }
  @media (max-width: 900px) { .btc-entity-guide-inner { padding: 48px 32px; } }
  .btc-eg-glow1 { position: absolute; top: 0; right: 0; width: 400px; height: 400px; background: radial-gradient(circle, rgba(139,92,246,0.22), transparent 70%); pointer-events: none; }
  .btc-eg-glow2 { position: absolute; bottom: 0; left: 0; width: 350px; height: 350px; background: radial-gradient(circle, rgba(16,185,129,0.12), transparent 70%); pointer-events: none; }
  .btc-eg-header { text-align: center; margin-bottom: 56px; position: relative; z-index: 1; }
  .btc-eg-header .btc-label { color: #c4b5fd; }
  .btc-eg-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .btc-eg-header p { font-size: 1.05rem; color: #94a3b8; margin-top: 16px; line-height: 1.7; }
  .btc-entity-table { width: 100%; position: relative; z-index: 1; overflow-x: auto; }
  .btc-et-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 16px; }
  @media (max-width: 900px) { .btc-et-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 500px) { .btc-et-grid { grid-template-columns: 1fr; } }
  .btc-et-col { background: rgba(30,41,59,0.5); border: 1px solid rgba(71,85,105,0.4); border-radius: 18px; padding: 24px; transition: border-color 0.3s; }
  .btc-et-col.highlight { background: rgba(124,58,237,0.15); border-color: rgba(139,92,246,0.4); }
  .btc-et-col:hover { border-color: rgba(139,92,246,0.5); }
  .btc-et-best { font-size: 10px; font-weight: 700; color: #c4b5fd; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 8px; }
  .btc-et-name { font-size: 1.05rem; font-weight: 800; color: #f1f5f9; margin-bottom: 16px; }
  .btc-et-rows { display: flex; flex-direction: column; gap: 10px; }
  .btc-et-row { }
  .btc-et-row-label { font-size: 11px; color: #64748b; font-weight: 500; margin-bottom: 2px; }
  .btc-et-row-val { font-size: 13px; color: #cbd5e1; font-weight: 600; }
  .btc-et-row-val.good { color: #6ee7b7; }
  .btc-et-row-val.bad { color: #fca5a5; }

  /* ─── Consulting Areas ───────────────────────────────────────── */
  .btc-deep { background: #f8fafc; }
  .btc-deep-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }
  @media (max-width: 768px) { .btc-deep-grid { grid-template-columns: 1fr; } }
  .btc-deep-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 20px; padding: 28px 32px; display: flex; gap: 20px; align-items: flex-start; transition: all 0.3s; }
  .btc-deep-card:hover { border-color: #ddd6fe; box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .btc-deep-emoji { font-size: 28px; flex-shrink: 0; margin-top: 2px; }
  .btc-deep-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
  .btc-deep-card p { font-size: 0.9rem; color: #64748b; line-height: 1.65; margin-bottom: 12px; }
  .btc-deep-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .btc-deep-tag { padding: 3px 10px; border-radius: 999px; font-size: 11px; font-weight: 600; background: #f1f5f9; color: #475569; }
  .btc-deep-card:hover .btc-deep-tag { background: #faf5ff; color: #7c3aed; }

  /* ─── Ideal Client ───────────────────────────────────────────── */
  .btc-ideal { background: #fff; }
  .btc-ideal-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 900px) { .btc-ideal-inner { grid-template-columns: 1fr; gap: 48px; } }
  .btc-ideal-left h2 { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .btc-ideal-left > p { font-size: 1.05rem; color: #64748b; line-height: 1.75; margin-bottom: 36px; }
  .btc-scenario-list { display: flex; flex-direction: column; gap: 14px; }
  .btc-scenario { padding: 16px 18px; background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px; transition: all 0.2s; }
  .btc-scenario:hover { background: #faf5ff; border-color: #ddd6fe; }
  .btc-scenario h4 { font-size: 14px; font-weight: 700; color: #1e293b; margin-bottom: 4px; }
  .btc-scenario p { font-size: 13px; color: #64748b; line-height: 1.55; }
  .btc-ideal-visual { background: #0f172a; border-radius: 24px; padding: 40px; position: relative; overflow: hidden; }
  .btc-ideal-glow { position: absolute; top: 0; right: 0; width: 250px; height: 250px; background: radial-gradient(circle, rgba(139,92,246,0.25), transparent 70%); pointer-events: none; }
  .btc-roi-label { font-size: 12px; color: #94a3b8; font-weight: 500; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 8px; }
  .btc-roi-title { font-size: 1.5rem; font-weight: 900; color: #fff; margin-bottom: 28px; line-height: 1.3; }
  .btc-roi-rows { display: flex; flex-direction: column; gap: 14px; }
  .btc-roi-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.06); }
  .btc-roi-row:last-child { border-bottom: none; }
  .btc-roi-item { font-size: 13px; color: #94a3b8; }
  .btc-roi-val { font-size: 14px; font-weight: 700; color: #c4b5fd; }

  /* ─── FAQ ───────────────────────────────────────────────────── */
  .btc-faq { background: #f8fafc; }
  .btc-faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
  @media (max-width: 768px) { .btc-faq-grid { grid-template-columns: 1fr; } }
  .btc-faq-item { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 26px; transition: all 0.2s; }
  .btc-faq-item:hover { border-color: #ddd6fe; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .btc-faq-q { font-size: 0.98rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; display: flex; gap: 10px; align-items: flex-start; }
  .btc-faq-q-icon { width: 22px; height: 22px; border-radius: 6px; background: #faf5ff; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #7c3aed; flex-shrink: 0; margin-top: 1px; }
  .btc-faq-a { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── CTA ────────────────────────────────────────────────────── */
  .btc-cta { background: #fff; border-top: 1px solid #f1f5f9; padding: 96px 24px; }
  .btc-cta-inner { background: #0f172a; border-radius: 32px; padding: 80px 48px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 600px) { .btc-cta-inner { padding: 48px 24px; } }
  .btc-cta-glow1 { position: absolute; top: 0; right: 0; width: 360px; height: 360px; background: radial-gradient(circle, rgba(139,92,246,0.25), transparent 70%); pointer-events: none; }
  .btc-cta-glow2 { position: absolute; bottom: 0; left: 0; width: 300px; height: 300px; background: radial-gradient(circle, rgba(16,185,129,0.15), transparent 70%); pointer-events: none; }
  .btc-cta-inner h2 { font-size: clamp(2rem,4vw,3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 20px; position: relative; z-index: 1; }
  .btc-cta-inner p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 540px; margin: 0 auto 40px; line-height: 1.75; position: relative; z-index: 1; }
  .btc-cta-btns { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 36px; }
  .btc-cta-primary { padding: 16px 32px; background: #7c3aed; color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 4px 20px rgba(124,58,237,0.4); }
  .btc-cta-primary:hover { background: #6d28d9; transform: translateY(-1px); }
  .btc-cta-secondary { padding: 16px 32px; background: rgba(255,255,255,0.06); color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .btc-cta-secondary:hover { background: rgba(255,255,255,0.1); }
  .btc-cta-badges { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .btc-cta-badge { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #94a3b8; }
  .btc-cta-badge-check { color: #c4b5fd; }
`;

const fadeIn = { initial:{opacity:0,y:28}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-50px'}, transition:{duration:0.55} };
const stagger = (i:number) => ({ initial:{opacity:0,y:24}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-40px'}, transition:{duration:0.5,delay:i*0.1} });

const areas = [
  { icon:'🏗️', bg:'#faf5ff', title:'Entity Structure Optimization', desc:'Selecting the right entity type and maintaining the right compensation structure can eliminate $10,000–$30,000+ in annual self-employment and payroll taxes.', impact:'Save $10K–$30K/yr' },
  { icon:'🔄', bg:'#f0fdf4', title:'Business Acquisition & Sale', desc:'Tax structure of a deal determines whether you pay 20% or 37%+ on proceeds. We advise buyers and sellers on asset vs. stock sales, earnouts, and installment sales.', impact:'Minimize exit taxes' },
  { icon:'🌱', bg:'#f0f9ff', title:'Growth Stage Planning', desc:'As your business scales — new employees, new markets, new investors — the tax implications multiply. We build scalable tax structures that grow with you.', impact:'Protect margins at scale' },
  { icon:'🗺️', bg:'#fefce8', title:'Multi-State Expansion', desc:'Expanding to new states creates nexus, new filing obligations, and apportionment complexity. We analyze tax exposure and build an efficient multi-state structure.', impact:'Avoid double taxation' },
  { icon:'🤝', bg:'#fff7ed', title:'Partnership & Shareholder Agreements', desc:'Tax-optimal operating agreements, buy-sell provisions, and waterfall structures that protect all parties and minimize phantom income and built-in gain issues.', impact:'Protect all stakeholders' },
  { icon:'🔬', bg:'#fdf4ff', title:'R&D Tax Credit Strategy', desc:'The research credit offsets taxes dollar-for-dollar and applies to more activities than most owners realize — software development, process improvements, and product design included.', impact:'Dollar-for-dollar credit' },
];

const entityCols = [
  { name:'Sole Prop / Single LLC', highlight:false, best:'', rows:[{label:'Self-employment tax',val:'15.3%',cls:'bad'},{label:'Owner deductions',val:'Limited',cls:''},{label:'Complexity',val:'Low',cls:'good'},{label:'Best for revenue',val:'Under $40K',cls:''}] },
  { name:'S-Corporation', highlight:true, best:'Most Common for $75K+ Revenue', rows:[{label:'Self-employment tax',val:'Eliminated on distributions',cls:'good'},{label:'Owner deductions',val:'Strong',cls:'good'},{label:'Complexity',val:'Moderate',cls:''},{label:'Best for revenue',val:'$75K–$5M',cls:'good'}] },
  { name:'C-Corporation', highlight:false, best:'', rows:[{label:'Corporate tax rate',val:'21% flat',cls:'good'},{label:'Double taxation risk',val:'On dividends',cls:'bad'},{label:'VC / Investor ready',val:'Yes (QSBS)',cls:'good'},{label:'Best for revenue',val:'VC-backed / high growth',cls:''}] },
  { name:'Partnership / Multi-Member LLC', highlight:false, best:'', rows:[{label:'Pass-through taxation',val:'Yes',cls:'good'},{label:'Flexibility',val:'Very high',cls:'good'},{label:'SE tax exposure',val:'General partners: full',cls:'bad'},{label:'Best for revenue',val:'Any — varies by structure',cls:''}] },
];

const deepDive = [
  { emoji:'💼', title:'Qualified Business Income (QBI) Deduction', desc:'Pass-through entity owners may deduct up to 20% of qualified business income. We optimize your W-2 wages, UBIA of qualified property, and income thresholds.', tags:['Section 199A','SSTB Rules','Wage & Capital Limit'] },
  { emoji:'🏛️', title:'Retirement Plan Design for Business Owners', desc:'Defined benefit plans, cash balance plans, and paired 401(k)/profit sharing plans can shelter $100,000–$300,000+ in pre-tax income for high earners.', tags:['Defined Benefit','Cash Balance','Solo 401(k)'] },
  { emoji:'📉', title:'Loss Harvesting & NOL Planning', desc:'Net operating losses can be carried forward to offset future profitable years. We design strategies to maximize the timing and value of NOL usage.', tags:['NOL Carryforward','Section 1231','Capital Loss Strategy'] },
  { emoji:'🌍', title:'International Tax Planning', desc:'For businesses with foreign income, contractors, or operations abroad, we structure arrangements to minimize worldwide tax exposure and ensure FBAR compliance.', tags:['FBAR','GILTI','Foreign Tax Credit'] },
  { emoji:'📊', title:'Compensation & Benefits Optimization', desc:'Salary vs. distributions, fringe benefits, accountable plans, and health reimbursement arrangements — optimizing the full compensation package for owner-employees.', tags:['HRA/QSEHRA','Accountable Plans','Officer W-2'] },
  { emoji:'🚪', title:'Exit & Succession Planning', desc:'Selling a business is often the biggest tax event of an owner\'s life. We plan 2–5 years out to maximize after-tax proceeds through installment sales, QSBS, and entity structure.', tags:['QSBS','Installment Sale','Section 1202'] },
];

const scenarios = [
  { title:'You\'re Earning $200K+ as a Self-Employed Owner', desc:'At this income level, entity structure and compensation optimization can save $15,000–$30,000+ annually in SE taxes and qualified income deductions.' },
  { title:'You\'re Considering Selling Your Business', desc:'The difference between an asset sale and stock sale, or the presence of QSBS stock, can mean hundreds of thousands in tax savings on the transaction.' },
  { title:'You\'re Expanding to 2 or More States', desc:'Multi-state nexus analysis, apportionment planning, and state tax minimization becomes essential when you have employees, offices, or significant revenue in multiple states.' },
  { title:'You\'re Raising Capital or Bringing on Partners', desc:'The tax structure of equity grants, unit distributions, and partner allocations determines who pays what tax and when — and must be designed correctly from the start.' },
];

const faqs = [
  { q:'How is consulting different from tax preparation?', a:'Preparation reports the past. Consulting shapes the future. Our consulting engagements focus on forward-looking decisions — entity structure, compensation design, acquisitions, and exit strategy — to minimize taxes before they occur.' },
  { q:'Should I convert my LLC to an S-Corporation?', a:'For most LLC owners earning $75,000+ in net profit, an S-Corp election reduces self-employment taxes significantly. We analyze your specific numbers, including salary requirements and administrative costs, to determine if conversion is beneficial.' },
  { q:'When should I start exit planning?', a:'Ideally 3–5 years before your target exit date. Many of the most valuable strategies — like holding QSBS stock for 5 years or restructuring before a sale — require lead time that can\'t be compressed.' },
  { q:'What\'s the cost of a consulting engagement?', a:'We offer project-based consulting for specific decisions and ongoing advisory retainers for complex businesses. All engagements are flat-fee, scoped upfront — no hourly billing or surprise invoices.' },
  { q:'Can you work with our existing legal counsel?', a:'Yes — and we recommend it. Coordinated advice between your tax advisor and business attorney ensures entity documents, operating agreements, and tax positions are all properly aligned.' },
  { q:'We\'re a startup — is this relevant to us?', a:'Absolutely. Early decisions about entity type, equity compensation (ISOs vs. NSOs vs. QSBS), and founder structuring have outsized long-term consequences. Getting it right at the start is far cheaper than unwinding mistakes later.' },
];

const BusinessTaxConsulting: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div className="btc-page">
    <style>{styles}</style>

    {/* Hero */}
    <section className="btc-hero">
      <div className="btc-hero-blob1" /><div className="btc-hero-blob2" />
      <div className="btc-hero-inner">
        <div>
          {onBack && (
            <button type="button" className="btc-back-btn" onClick={onBack}>
              <span aria-hidden="true">←</span> Back to Tax Services
            </button>
          )}
          <motion.div initial={{opacity:0,scale:0.9}} animate={{opacity:1,scale:1}} transition={{duration:0.5}}>
            <div className="btc-hero-badge"><span className="btc-badge-dot" />Strategic tax advice for growing businesses</div>
          </motion.div>
          <motion.h1 initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.1}}>
            Turn Your Tax Strategy Into a<br /><span className="btc-gradient-text">Competitive Advantage</span>
          </motion.h1>
          <motion.p initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.2}}>
            Beyond filing, beyond compliance — our business tax consulting service focuses on the decisions that shape your company's financial future: entity structure, exit planning, multi-state expansion, and growth-stage strategy.
          </motion.p>
          <motion.div className="btc-btn-group" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5,delay:0.3}}>
            <button type="button" className="btc-btn-primary">Schedule a Strategy Session →</button>
            <button type="button" className="btc-btn-secondary">See How It Works</button>
          </motion.div>
        </div>
        <motion.div className="btc-hero-visual" initial={{opacity:0,x:40}} animate={{opacity:1,x:0}} transition={{duration:0.7,delay:0.2}}>
          <div className="btc-vis-header">
            <div className="btc-vis-title"><p>Entity Analysis</p><p>Apex Design Studio LLC</p></div>
            <div className="btc-vis-icon">📊</div>
          </div>
          <div className="btc-entity-compare">
            <div className="btc-entity current">
              <div className="btc-entity-tag current">Current Structure</div>
              <div className="btc-entity-name">Single-Member LLC</div>
              <div className="btc-entity-tax">Self-employment tax: 15.3%</div>
              <div className="btc-entity-amount bad">$28,400 / yr</div>
            </div>
            <div className="btc-entity recommended">
              <div className="btc-entity-tag recommended">Recommended</div>
              <div className="btc-entity-name">S-Corporation Election</div>
              <div className="btc-entity-tax">SE tax on salary only</div>
              <div className="btc-entity-amount good">$11,200 / yr</div>
            </div>
          </div>
          <div className="btc-entity-savings">
            <span>Annual Tax Savings from Restructure</span>
            <span>$17,200 / yr</span>
          </div>
        </motion.div>
      </div>
    </section>

    {/* Stats */}
    <div className="btc-stats">
      <div className="btc-stats-grid">
        {[
          {num:'$17K+',label:'Average Entity Optimization Savings',dark:false},
          {num:'500+',label:'Business Consulting Clients Served',dark:false},
          {num:'15+',label:'Years Advising Business Owners',dark:true},
          {num:'Full',label:'Spectrum: Startup to Exit',dark:true},
        ].map((s,i) => (
          <motion.div className="btc-stat" key={i} {...stagger(i)}>
            <div className={`btc-stat-num${s.dark?' dark':''}`}>{s.num}</div>
            <div className="btc-stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Areas */}
    <section className="btc-section btc-areas">
      <div className="btc-container">
        <motion.div className="btc-section-header" {...fadeIn}>
          <span className="btc-label">Consulting Areas</span>
          <h2>Strategic Tax Decisions That Shape Your Business</h2>
          <p>These are the high-stakes decisions where expert tax consulting pays for itself many times over — often in the first year.</p>
        </motion.div>
        <div className="btc-areas-grid">
          {areas.map((a,i) => (
            <motion.div className="btc-area-card" key={i} {...stagger(i)}>
              <div className="btc-area-icon" style={{background:a.bg}}>{a.icon}</div>
              <h3>{a.title}</h3>
              <p>{a.desc}</p>
              <span className="btc-area-impact">{a.impact}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Entity Guide */}
    <section className="btc-section btc-entity-guide">
      <div className="btc-container">
        <div className="btc-entity-guide-inner">
          <div className="btc-eg-glow1" /><div className="btc-eg-glow2" />
          <motion.div className="btc-eg-header" {...fadeIn}>
            <span className="btc-label">Entity Selection</span>
            <h2>Choosing the Right Business Structure</h2>
            <p>Entity type is one of the most impactful tax decisions a business owner makes. Here's how the main options compare — and where each makes the most sense.</p>
          </motion.div>
          <div className="btc-entity-table">
            <div className="btc-et-grid">
              {entityCols.map((col,i) => (
                <motion.div className={`btc-et-col${col.highlight?' highlight':''}`} key={i} {...stagger(i)}>
                  {col.best && <div className="btc-et-best">★ {col.best}</div>}
                  <div className="btc-et-name">{col.name}</div>
                  <div className="btc-et-rows">
                    {col.rows.map((row,j) => (
                      <div className="btc-et-row" key={j}>
                        <div className="btc-et-row-label">{row.label}</div>
                        <div className={`btc-et-row-val${row.cls?' '+row.cls:''}`}>{row.val}</div>
                      </div>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Deep Dive */}
    <section className="btc-section btc-deep">
      <div className="btc-container">
        <motion.div className="btc-section-header" {...fadeIn}>
          <span className="btc-label">Advanced Strategy</span>
          <h2>Deep-Dive Tax Consulting Specializations</h2>
          <p>For complex business situations, we bring expertise across all major advanced tax planning disciplines.</p>
        </motion.div>
        <div className="btc-deep-grid">
          {deepDive.map((d,i) => (
            <motion.div className="btc-deep-card" key={i} {...stagger(i)}>
              <span className="btc-deep-emoji">{d.emoji}</span>
              <div>
                <h3>{d.title}</h3>
                <p>{d.desc}</p>
                <div className="btc-deep-tags">{d.tags.map((t,j) => <span className="btc-deep-tag" key={j}>{t}</span>)}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Ideal Client */}
    <section className="btc-section btc-ideal">
      <div className="btc-container">
        <div className="btc-ideal-inner">
          <motion.div className="btc-ideal-left" {...fadeIn}>
            <span className="btc-label">Who This Is For</span>
            <h2>Situations Where Consulting Makes the Biggest Difference</h2>
            <p>Business tax consulting has the highest ROI for owners facing significant decisions, major milestones, or structural complexity.</p>
            <div className="btc-scenario-list">
              {scenarios.map((s,i) => (
                <motion.div className="btc-scenario" key={i} {...stagger(i)}>
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
          <motion.div className="btc-ideal-visual" initial={{opacity:0,x:30}} whileInView={{opacity:1,x:0}} viewport={{once:true}} transition={{duration:0.6,delay:0.2}}>
            <div className="btc-ideal-glow" />
            <div className="btc-roi-label">What a Strategy Session Delivers</div>
            <div className="btc-roi-title">Clarity on Your Most Important Tax Decisions</div>
            <div className="btc-roi-rows">
              {[
                {item:'Entity structure analysis & recommendation',val:'Included'},
                {item:'Compensation optimization modeling',val:'Included'},
                {item:'Multi-year tax projection',val:'Included'},
                {item:'Retirement plan recommendation',val:'Included'},
                {item:'Written strategy summary',val:'Included'},
                {item:'Implementation roadmap',val:'Included'},
                {item:'Follow-up Q&A session',val:'Included'},
              ].map((row,i) => (
                <div className="btc-roi-row" key={i}>
                  <span className="btc-roi-item">{row.item}</span>
                  <span className="btc-roi-val">{row.val}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="btc-section btc-faq">
      <div className="btc-container">
        <motion.div className="btc-section-header" {...fadeIn}>
          <span className="btc-label">Common Questions</span>
          <h2>Your Business Tax Consulting Questions Answered</h2>
          <p>Ready to talk through your specific situation? Our first strategy session is free — no obligation.</p>
        </motion.div>
        <div className="btc-faq-grid">
          {faqs.map((f,i) => (
            <motion.div className="btc-faq-item" key={i} {...stagger(i)}>
              <div className="btc-faq-q"><div className="btc-faq-q-icon">?</div>{f.q}</div>
              <div className="btc-faq-a">{f.a}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="btc-cta">
      <div className="btc-cta-inner">
        <div className="btc-cta-glow1" /><div className="btc-cta-glow2" />
        <motion.h2 {...fadeIn}>Your Next Big Decision Deserves Expert Tax Advice</motion.h2>
        <motion.p {...{...fadeIn,transition:{duration:0.55,delay:0.1}}}>
          The right tax structure, at the right time, can save your business six figures. Let's review your situation and build a strategy built around your goals.
        </motion.p>
        <motion.div className="btc-cta-btns" {...{...fadeIn,transition:{duration:0.5,delay:0.2}}}>
          <button type="button" className="btc-cta-primary">Schedule a Strategy Session →</button>
          <button type="button" className="btc-cta-secondary">Learn More</button>
        </motion.div>
        <motion.div className="btc-cta-badges" {...{...fadeIn,transition:{duration:0.5,delay:0.3}}}>
          {['Free first strategy session','Flat-fee project pricing','Licensed CPAs only','No ongoing commitment required'].map((b,i) => (
            <div className="btc-cta-badge" key={i}><span className="btc-cta-badge-check">✓</span>{b}</div>
          ))}
        </motion.div>
      </div>
    </section>
  </div>
);

export default BusinessTaxConsulting;
